
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType } from "@/types/Application/CommonInformation";
import { getLocationInfo } from '@/components/utils/PopulateForms/PopulateCommonInformation';
import { noticeRemoveLawyerChildDataInfoType, childInformationNlcrDataInfoType } from '@/types/Application/NoticeRemoveLawyerChild';

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})
export default class Form41Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false;  
    existingFileNumber = '';    
    acknowledgeService = false;

    childDetails: childInformationNlcrDataInfoType[] =[{name:'', dob: ''}];
    childTableFields = [
        {key:"name",label:"Child’s full name",     tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:55%;"},
        {key:"dob", label:"Child’s Date of Birth", tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:35%;"},
    ];
   
    mounted(){
        this.dataReady = false;
        //console.log(this.result)
        this.extractInfo();       
        this.dataReady = true;        
    }
   
    public extractInfo(){     
        this.existingFileNumber = getLocationInfo(this.result.otherFormsFilingLocationSurvey);
        this.acknowledgeService = this.result.otherPartyNLCRConfirmationSurvey?.confirmation == 'Confirmed';
        this.getNoticeRemoveLawyerChildInfo();     
    } 

    public getNoticeRemoveLawyerChildInfo(){ 
       
        this.childDetails = [{name: '', dob: ''}];        

        if(this.result?.noticeRemoveLawyerChildSurvey){

            let noticeRemoveLawyerChild = {} as noticeRemoveLawyerChildDataInfoType;
            noticeRemoveLawyerChild = this.result.noticeRemoveLawyerChildSurvey; 
            
            const childrenInfo = [];

            for (const child of noticeRemoveLawyerChild.ChildInfoNlcr){
                const childInfo = {} as childInformationNlcrDataInfoType;
                childInfo.dob = child.dateOfBirth?Vue.filter('beautify-date')(child.dateOfBirth):'';
                childInfo.name = child.name?Vue.filter('getFullName')(child.name):'';
                childrenInfo.push(childInfo);
            }

            if (childrenInfo.length>0){
                this.childDetails = childrenInfo;
            }                      
        }             
    } 
}
